import { NewUserCoupon, UserInfo } from '@/types/account';
import { Address } from '@/types/address';

export const SYNC_ACCOUNT_INFO = '@/SYNC_ACCOUNT_INFO';
export const syncAccountInfo = (payload: UserInfo) => {
  return {
    type: SYNC_ACCOUNT_INFO,
    payload: payload
  };
};

export const RESET_ACCOUNT_INFO = '@/RESET_ACCOUNT_INFO';
export const resetAccountInfo = () => {
  return {
    type: RESET_ACCOUNT_INFO
  };
};

export const SYNC_LOGIN_STATE = '@/SYNC_LOGIN_STATE';
export const syncLoginState = (payload: boolean) => {
  return {
    type: SYNC_LOGIN_STATE,
    payload: payload
  };
};

export const SYNC_FAVORITE_IDS = '@/SYNC_FAVORITE_IDS';
export const syncFavoriteIds = (payload: number[]) => {
  return {
    type: SYNC_FAVORITE_IDS,
    payload: payload
  };
};

export const SYNC_ADDRESS_BOOK = '@/SYNC_ADDRESS_BOOK';
export const syncAddressBook = (payload: Address[]) => {
  return {
    type: SYNC_ADDRESS_BOOK,
    payload: payload
  };
};

export const SET_TIME_BANNER_COUPON = '@/SET_TIME_BANNER_COUPON';
export const setTimeBannerCoupon = (payload: number) => {
  return {
    type: SET_TIME_BANNER_COUPON,
    payload: payload
  };
};

export const SET_DISCOUNT_COPY = '@/SET_DISCOUNT_COPY';
export const setDiscountCopy = (payload: any) => {
  return {
    type: SET_DISCOUNT_COPY,
    payload: payload
  };
};

export const SYNC_COMMON_BAR_COPY = '@/SYNC_COMMON_BAR_COPY';
export const syncCommonBarCopy = (payload: any) => {
  return {
    type: SYNC_COMMON_BAR_COPY,
    payload: payload
  };
};

export const SYNC_REWARDS_INFO = '@/SYNC_REWARDS_INFO';
export const syncRewardsInfo = (payload: any) => {
  return {
    type: SYNC_REWARDS_INFO,
    payload: payload
  };
};

export const SHOW_FAVORITE_TIP = '@/SHOW_FAVORITE_TIP';
export const setShowFavoriteTip = (payload: any) => {
  return {
    type: SHOW_FAVORITE_TIP,
    payload: payload
  };
};

export const SYNC_USER_PRE_ORDER_LOGIN = '@/SYNC_USER_PRE_ORDER_LOGIN';
export const syncUserPreOrderLogin = (payload: boolean) => {
  return {
    type: SYNC_USER_PRE_ORDER_LOGIN,
    payload: payload
  };
};

export const SYNC_FAVORITE_CLICK = '@/SYNC_FAVORITE_CLICK';
export const syncFavoriteClick = (payload: boolean) => {
  return {
    type: SYNC_FAVORITE_CLICK,
    payload: payload
  };
};

export const SYNC_USER_BOUGHT_DATA = '@/SYNC_USER_BOUGHT_DATA';
export const syncUserBoughtData = (payload: any[]) => {
  return {
    type: SYNC_USER_BOUGHT_DATA,
    payload: payload
  };
};

export const SYNC_PDP_SOLDOUT_TIP = '@/SYNC_PDP_SOLDOUT_TIP';
export const syncPdpSoldoutTip = (payload: boolean) => {
  return {
    type: SYNC_PDP_SOLDOUT_TIP,
    payload: payload
  };
};
